import { ViewOption } from 'types/viewOptions';
import AdListGridItem from './AdListGridItem';
import AdListFlatItem from './AdListFlatItem';
import AdListHeader from './AdListHeader';
import { SortingOptions } from 'types/sortingOptions';
import { AdListing } from 'types/adListing';
import { useAuth } from 'contexts/AuthContext';

interface AdListProps {
  sortedIlanlar: AdListing[];
  totalMatchingCount: number;
  itemsPerPage: number;
  currentPage: number;
  totalPages: number;
  sortOption: SortingOptions;
  handleSortChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  viewType: ViewOption;
  onViewChange: (view: ViewOption) => void;
  detailLinkBase?: string;
  onToggleFavorite?: (id: string | number, e: React.MouseEvent) => void;
  displayFavorites?: boolean;
  displayEdit?: boolean;
  displayDelete?: boolean;
  /** Optional content at the start of the header (e.g. mobile filter toggle button) */
  headerLeftAddon?: React.ReactNode;
}

function isListingOwner(ilan: AdListing, currentUserId: string | undefined): boolean {
  return (
    ilan.ownerUserId != null &&
    ilan.ownerUserId !== '' &&
    currentUserId != null &&
    currentUserId === ilan.ownerUserId
  );
}

export default function AdList({
  sortedIlanlar,
  totalMatchingCount,
  itemsPerPage,
  currentPage,
  totalPages,
  sortOption,
  handleSortChange,
  viewType = ViewOption.GRID,
  onViewChange,
  detailLinkBase,
  onToggleFavorite,
  displayFavorites = true,
  displayEdit = false,
  displayDelete = false,
  headerLeftAddon,
}: AdListProps) {
  const { user } = useAuth();
  const currentUserId = user?.id;
  const currentItems = sortedIlanlar;
  return (
    <>
      <AdListHeader sortedIlanlar={sortedIlanlar} totalMatchingCount={totalMatchingCount} itemsPerPage={itemsPerPage} currentPage={currentPage} totalPages={totalPages} sortOption={sortOption} viewType={viewType} handleSortChange={handleSortChange} onViewChange={onViewChange} leftAddon={headerLeftAddon} />

      {viewType === ViewOption.GRID && (
        <div className="sb-listing-grid">
          {currentItems.map((ilan) => (
            <AdListGridItem
              key={ilan.id}
              ilan={ilan}
              detailLinkBase={detailLinkBase}
              onToggleFavorite={onToggleFavorite}
              displayFavorites={displayFavorites && !isListingOwner(ilan, currentUserId)}
              displayEdit={displayEdit}
              displayDelete={displayDelete}
            />
          ))}
        </div>
      )}
      {viewType === ViewOption.LIST && (
        <div className="list-view">
          {currentItems.map((ilan) => (
            <AdListFlatItem
              key={ilan.id}
              ilan={ilan}
              detailLinkBase={detailLinkBase}
              onToggleFavorite={onToggleFavorite}
              displayFavorites={displayFavorites && !isListingOwner(ilan, currentUserId)}
            />
          ))}
        </div>
      )}
    </>
  )
}